/* eslint-disable */

const dicts = {
  transferType () {
    return [
      { label: '转入', value: 1 },
      { label: '转出', value: 2 },
    ]
  },
  isNormal () {
    return [
      { label: '否', value: 0 },
      { label: '是', value: 1 },
    ]
  },
  isHas () {
    return [
      { label: '无', value: 0 },
      { label: '有', value: 1 },
    ]
  },
  whether () {
    return [
      { label: '否', value: 0 },
      { label: '是', value: 1 },
    ]
  },
  attendType () {
    return [
      { label: '参加上级组织举办的各种会议和培训', value: 1 },
      { label: '承担或参与完成上级组织开展的社会服务工作', value: 2 },
      { label: '积极参加上级组织参政议政工作学习、培训、会议等活动', value: 3 },
      { label: '积极参加上级组织社会服务工作学习、培训、会议等活动', value: 4 },
      { label: '积极参加上级组织祖统工作学习、培训、会议等活动', value: 5 },
    ]
  },
  userType () {
    return [
      { label: '支部', value: 1 },
      { label: '部分党员', value: 2 },
      { label: '个别党员', value: 3 },
    ]
  },
  popularizeType () {
    return [
      { label: '新闻稿', value: 1 },
      { label: '理论文章', value: 2 },
      { label: '书籍', value: 3 },
      { label: '各类会议大会发言或书面交流', value: 4 },
      { label: '征文评选', value: 5 },
    ]
  },
  submitChannel () {
    return [
      {
        label: '人大',
        value: '人大',
        children: [
          { label: '中央', value: '中央' },
          { label: '省级', value: '省级' },
          { label: '市级', value: '市级' },
          { label: '市级以下', value: '市级以下' },
        ],
      },
      {
        label: '政协',
        value: '政协',
        children: [
          { label: '中央', value: '中央' },
          { label: '省级', value: '省级' },
          { label: '市级', value: '市级' },
          { label: '市级以下', value: '市级以下' },
        ],
      },
      {
        label: '统战部',
        value: '统战部',
        children: [
          { label: '中央', value: '中央' },
          { label: '省级', value: '省级' },
          { label: '市级', value: '市级' },
          { label: '市级以下', value: '市级以下' },
        ],
      },
      {
        label: '民革组织',
        value: '民革组织',
        children: [
          { label: '中央', value: '中央' },
          { label: '省级', value: '省级' },
          { label: '市级', value: '市级' },
          { label: '市级以下', value: '市级以下' },
        ],
      },
    ]
  },
  rewardStatus () {
    return [
      {
        label: '人大',
        value: '人大',
        children: [
          { label: '中央', value: '中央' },
          { label: '省级', value: '省级' },
          { label: '市级', value: '市级' },
          { label: '市级以下', value: '市级以下' },
        ],
      },
      {
        label: '政协',
        value: '政协',
        children: [
          { label: '中央', value: '中央' },
          { label: '省级', value: '省级' },
          { label: '市级', value: '市级' },
          { label: '市级以下', value: '市级以下' },
        ],
      },
      {
        label: '统战部',
        value: '统战部',
        children: [
          { label: '中央', value: '中央' },
          { label: '省级', value: '省级' },
          { label: '市级', value: '市级' },
          { label: '市级以下', value: '市级以下' },
        ],
      },
      {
        label: '民革组织',
        value: '民革组织',
        children: [
          { label: '中央', value: '中央' },
          { label: '省级', value: '省级' },
          { label: '市级', value: '市级' },
          { label: '市级以下', value: '市级以下' },
        ],
      },
      {
        label: '无',
        value: '无',
      },
    ]
  },
  category () {
    return [
      { label: '祖统', value: 1 },
      { label: '社会和法制', value: 2 },
      { label: '三农', value: 3 },
      { label: '其他', value: 4 },
    ]
  },
  carryTime () {
    return [
      { label: '1-5年', value: 1 },
      { label: '5-10年', value: 2 },
      { label: '10年及以上', value: 3 },
    ]
  },
  categoryBrand () {
    return [
      { label: '经济', value: 1 },
      { label: '教育', value: 2 },
      { label: '文化', value: 3 },
      { label: '法律援助', value: 4 },
      { label: '博爱牵手', value: 5 },
      { label: '民主监督', value: 6 },
      { label: '创新品牌', value: 7 },
      { label: '其他', value: 9 },
    ]
  },
  honourLevel () {
    return [
      { label: '中央', value: 1 },
      { label: '省级', value: 2 },
      { label: '市级', value: 3 },
      { label: '市级以下', value: 4 },
      { label: '无', value: 5 },
    ]
  },
  orgType () {
    return [
      { label: '省委会', value: 1 },
      { label: '市委会', value: 2 },
      { label: '县委会', value: 3 },
      { label: '基层委员会', value: 4 },
      { label: '总支部', value: 5 },
      { label: '支部', value: 6 },
    ]
  },
  schemeType () {
    return [
      { label: '工作制度', value: 1 },
      { label: '学习制度', value: 2 },
      { label: '财务制度', value: 3 },
      { label: '档案管理制度', value: 4 },
      { label: '创新制度', value: 5 },
      { label: '其他制度', value: 9 },
    ]
  },
  gender () {
    return [
      { label: '男', value: 1 },
      { label: '女', value: 2 },
    ]
  },
  socialRelationship () {
    return [
      { label: '传统特色', value: 1 },
      { label: '社会', value: 2 },
      { label: '法制', value: 3 },
      { label: '三农', value: 4 },
      { label: '无', value: 5 },
    ]
  },
  stage () {
    return [
      { label: '提交入党申请书', value: 1 },
      { label: '支部和所属地方组织考察', value: 2 },
      { label: '支部大会通过', value: 3 },
      { label: '地方组织审核', value: 4 },
      { label: '省辖市级组织（省级组织）批准', value: 5 },
      { label: '省级组织备案', value: 6 },
      { label: '中央组织部备案', value: 7 },
      { label: '书面通知本人及所在单位', value: 8 },
    ]
  },
  branchState () {
    return [
      { label: '民革模范支部', value: '0' },
      { label: '第一批全国示范支部', value: '101' },
      { label: '第二批全国示范支部', value: '102' },
      { label: '第三批全国示范支部', value: '103' },
      { label: '省级示范支部', value: '2' },
      { label: '市级示范支部', value: '3' },
      { label: '其它', value: '4' },
    ]
  },
  lookBack () {
    return [
      { label: '中央（2025）', value: '1_2025' },
      { label: '省级（2025）', value: '2_2025' },
      { label: '市级（2025）', value: '3_2025' },
      // { label: '未开展（2025）', value: '4_2025' },
      { label: '中央（2024）', value: '1_2024' },
      { label: '省级（2024）', value: '2_2024' },
      { label: '市级（2024）', value: '3_2024' },
      // { label: '未开展（2024）', value: '4_2024' },
      { label: '中央（2023）', value: '1_2023' },
      { label: '省级（2023）', value: '2_2023' },
      { label: '市级（2023）', value: '3_2023' },
      { label: '未开展', value: '4_2025' }
    ]        
  },
  address () {
    return [
      { label: '自有党员之家', value: '自有党员之家' },
      { label: '共有党员之家', value: '共有党员之家' },
      { label: '有其他固定活动场所', value: '有其他固定活动场所' },
      { label: '无固定活动场所', value: '无固定活动场所' },
    ]
  },
  activityType () {
    return [
      { label: '思想政治学习', value: 1 },
      {
        label: '支部组织生活（含联谊、关爱党员活动、志愿服务、与社区共建、与中共基层组织共建等）',
        value: 2,
      },
      { label: '参政议政调研', value: 3 },
      { label: '社会服务工作（含民主监督）', value: 4 },
      { label: '祖统工作', value: 5 },
      { label: '纪律学习教育（含廉政警示等）', value: 7 },
      { label: '主题教育知识问答学习活动', value: 8 },
      { label: '其他', value: 6 },
    ]
  },
  circles () {
    return [
      { label: '传统特色', value: 1 },
      { label: '社会', value: 2 },
      { label: '法制', value: 3 },
      { label: '三农', value: 4 },
      { label: '无', value: 5 },
    ]
  },
  eventType () {
    return [
      { label: '理论学习', value: 1 },
      { label: '调研座谈', value: 2 },
      { label: '组织会议', value: 3 },
      { label: '社会服务', value: 4 },
      { label: '交流联谊', value: 5 },
    ]
  },
  subject () {
    return [
      {
        label: '学习贯彻中共各级组织会议精神',
        value: 1,
      },
      {
        label: '学习贯彻民革各级组织会议精神',
        value: 2,
      },
      {
        label: '党史党章教育培训活动或会议',
        value: 3,
      },
      { label: '主题教育', value: 4 },
      { label: '支部工作', value: 5 },
      { label: '其他', value: 9 },
    ]
  },
  // branchType () {
  //   return [
  //     { label: '单一支部', value: '单一支部' },
  //     { label: '行业支部', value: '行业支部' },
  //     { label: '综合支部', value: '综合支部' },
  //     { label: '其他', value: '其他' },
  //   ]
  // }
  branchType () {
    return [
      { label: '综合性支部', value: 1 },
      { label: '行业性支部', value: 2 },
      { label: '其它', value: 3 }
    ]
  },

  branchPermissons () {
    return [
      { label: '民革中央', value: 1 },
      { label: '民革省委', value: 2 },
      { label: '民革市委', value: 3 },
      { label: '民革区县委（基层委、总支）', value: 4 },
      { label: '民革支部', value: 5 },
    ]
  }
}

export default dicts
